import { Component, Host, h, Prop } from '@stencil/core';

@Component({
  tag: 'me-grid',
  styleUrl: 'me-grid.scss',
  shadow: false,
})
export class MeGrid {

  @Prop() rows = 1;
  @Prop() columns = 12;
  @Prop() gap = 4;
  @Prop() horizontalGap?: number = null;
  @Prop() verticalGap?: number = null;

  render() {
    const classList = [
      'me-grid',
    ].filter(c => !!c).join(' ');

    return (
      <Host
        class={classList}
        style={{
          '--me-rows': `${this.rows}`,
          '--me-columns': `${this.columns}`,
          '--me-gap': `calc(var(--me-space, 4px) * ${this.verticalGap ?? this.gap}) calc(var(--me-space, 4px) * ${this.horizontalGap ?? this.gap})`,
        }}
      >
        <slot></slot>
      </Host>
    );
  }

}
